// extracted by mini-css-extract-plugin
export default {"home":"style_home__SS37J","fadeIn":"style_fadeIn__S2i+S","backgroundAnimation":"style_backgroundAnimation__G9KYN","title":"style_title__QhDrU","subtitle":"style_subtitle__bk32i"};